import {UI} from "../../../stem-core/ui/UIBase.js";
import {registerStyle, styleRule, StyleSheet} from "../../../stem-core/ui/Style";
import {Select} from "../../../stem-core/ui/input/Input.jsx";
import {pluralize} from "../../../stem-core/base/Utils";
import {SearchInput} from "../../ui/input/SearchInput.jsx";

// TODO @Mihai merge with SubscriptionOfferSelectInput, only the formatter and the labels differ.


// Journeys are referenced by alias everywhere else, so show it next to the name and search in both.
function formatJourney(journey) {
    return journey.alias ? `${journey.name} (${journey.alias})` : journey.name;
}


class JourneySelectInputStyle extends StyleSheet {
    @styleRule
    matchCount = {
        color: this.themeProps.DASHBOARD_DESCRIPTION_COLOR,
        fontSize: this.themeProps.FONT_SIZE_SMALL,
        marginBottom: 8,
    };

    // Without this the dropdown is as wide as its longest journey name, and spills out of the dialog.
    @styleRule
    select = {
        width: "100%",
    };
}


// A journey dropdown with a search box on top, for merchants that have too many journeys to eyeball.
@registerStyle(JourneySelectInputStyle)
export class JourneySelectInput extends UI.Element {
    search = "";

    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            journeys: [],
            placeholder: "Search by name or alias",
            noMatchMessage: "No journey matches your search.",
        };
    }

    getMatchingJourneys() {
        const search = this.search.toLowerCase();
        return this.options.journeys
            .filter(journey => formatJourney(journey).toLowerCase().includes(search))
            .sort((a, b) => a.name.localeCompare(b.name));
    }

    // Null while the search filters out everything, since then there's no dropdown to select from.
    getValue() {
        return this.getMatchingJourneys().length ? this.select.get() : null;
    }

    focus() {
        this.searchInput.focus();
    }

    onSearchChange(search) {
        this.search = search;
        this.redraw();
        this.dispatchChange(this.getValue());
    }

    getMatchMessage(matchingJourneys) {
        const total = this.options.journeys.length;
        if (!matchingJourneys.length) {
            return this.options.noMatchMessage;
        }
        if (matchingJourneys.length === total) {
            return pluralize(total, "journey");
        }
        return `${matchingJourneys.length} of ${pluralize(total, "journey")}`;
    }

    render() {
        const {styleSheet} = this;
        const {placeholder} = this.options;
        const matchingJourneys = this.getMatchingJourneys();

        return [
            <SearchInput ref="searchInput"
                         inputAttributes={{placeholder}}
                         onChange={(search) => this.onSearchChange(search)}/>,
            <div className={styleSheet.matchCount}>{this.getMatchMessage(matchingJourneys)}</div>,
            matchingJourneys.length ?
                <Select ref="select"
                        className={styleSheet.select}
                        options={matchingJourneys}
                        formatter={formatJourney}
                        onChange={() => this.dispatchChange(this.getValue())}/> :
                null,
        ];
    }
}